import axios from "axios";
import React from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import toastr from "toastr";

function NewInterviewer({ role_id, onClose }) {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      interviewers: [
        {
          clientFname: "",
          clientLname: "",
          clientemail: "",
          clientLinedinUrl: "",
          clientdesignation: "",
          LinkedinAvailable: true,
        },
      ],
    },
  });

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "interviewers",
  });

  const onSubmit = async (data) => {
    data = {
      ...data,
      role_id: role_id,
    };
    setGlobalLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/workstation/add_interviewer`,
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(res);
      if (res.status === 200) {
        toastr.success(res.data.message);
        onClose(1);
      }
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  // Watch all interviewers to reactively control fields
  const interviewers = watch("interviewers");

  const toggleLinkedin = (index) => {
    const current = interviewers[index];
    const newValue = !current.LinkedinAvailable;

    // Update the LinkedinAvailable flag
    setValue(`interviewers.${index}.LinkedinAvailable`, newValue);

    // If unchecked, clear Linkedin URL
    if (!newValue) {
      setValue(`interviewers.${index}.clientLinedinUrl`, "");
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-lg" style={{ maxWidth: "75pc" }}>
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Add More Interviewer</h4>
            <button
              type="button"
              className="btn btn-sm btn-info"
              onClick={() =>
                append({
                  clientFname: "",
                  clientLname: "",
                  clientemail: "",
                  clientLinedinUrl: "",
                  clientdesignation: "",
                  LinkedinAvailable: true,
                })
              }
            >
              Add More
            </button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-body">
              {fields.map((field, index) => {
                const linkedinAvailable =
                  interviewers[index]?.LinkedinAvailable;

                return (
                  <div className="row" key={field.id}>
                    {/* First Name */}
                    <div className="col-md-2">
                      <div className="mb-3">
                        <label className="form-label">
                          First Name{" "}
                          <span className="text-danger">
                            *{" "}
                            {
                              errors?.interviewers?.[index]?.clientFname
                                ?.message
                            }
                          </span>
                        </label>
                        <input
                          {...register(`interviewers.${index}.clientFname`, {
                            required: "Required",
                          })}
                          className="form-control"
                        />
                      </div>
                    </div>

                    {/* Last Name */}
                    <div className="col-md-2">
                      <div className="mb-3">
                        <label className="form-label">
                          Last Name{" "}
                          <span className="text-danger">
                            *{" "}
                            {
                              errors?.interviewers?.[index]?.clientLname
                                ?.message
                            }
                          </span>
                        </label>
                        <input
                          {...register(`interviewers.${index}.clientLname`, {
                            required: "Required",
                          })}
                          className="form-control"
                        />
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-md-2">
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          {...register(`interviewers.${index}.clientemail`)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    {/* Linkedin */}
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Linkedin
                          {linkedinAvailable && (
                            <span className="text-danger">
                              *{" "}
                              {
                                errors?.interviewers?.[index]?.clientLinedinUrl
                                  ?.message
                              }
                            </span>
                          )}
                          <span>
                            <input
                              type="checkbox"
                              className="mt-1 ms-2"
                              checked={!linkedinAvailable}
                              onChange={() => toggleLinkedin(index)}
                            />{" "}
                            Not Available
                          </span>
                        </label>
                        <input
                          {...register(
                            `interviewers.${index}.clientLinedinUrl`,
                            {
                              required: linkedinAvailable ? "Required" : false,
                            }
                          )}
                          type="url"
                          className="form-control"
                          disabled={!linkedinAvailable}
                        />
                      </div>
                    </div>

                    {/* Designation */}
                    <div className="col-md-2">
                      <label className="form-label">
                        Designation{" "}
                        <span className="text-danger">
                          *{" "}
                          {
                            errors?.interviewers?.[index]?.clientdesignation
                              ?.message
                          }
                        </span>
                      </label>
                      <div className="mb-3 d-flex">
                        <input
                          {...register(
                            `interviewers.${index}.clientdesignation`,
                            {
                              required: "Required",
                            }
                          )}
                          className="form-control"
                        />
                        {index !== 0 && (
                          <button
                            type="button"
                            onClick={() => remove(index)}
                            className="btn btn-danger btn-sm ms-2"
                          >
                            <i className="ti ti-trash"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-primary mx-1">
                Save
              </button>
              <button
                type="button"
                onClick={() => onClose()}
                className="btn btn-secondary"
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default NewInterviewer;
